import { selectParams } from '@oneappexchange/lwc-wired';
import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '../../config';
import { routerStore } from '../stores/routerStore';
import { handleNetworkError, withVersionHeaders } from '../utilities/axiosUtilities';
export function getListings({
  page = 0,
  limit = 10,
  publicListings = false,
  marketplace
} = {}) {
  let url = `${PUBLISHING_SERVICE_URL}/publishing/streams/listings?page=${page}&limit=${limit}${marketplace ? `&marketplace=${marketplace}` : ''}`;
  const params = selectParams(routerStore.getState()) || {};
  url += params.sortBy ? `&sortBy=${params.sortBy}` : `&sortBy=user_updated_at`;
  url += params.sortOrder ? `&sortOrder=${params.sortOrder}` : `&sortOrder=desc`;
  url += params.technology ? `&technology=${params.technology}` : '';
  url += params.searchTerm ? `&searchTerm=${params.searchTerm}` : '';
  url += publicListings || params.public ? `&public=${publicListings || params.public}` : '';
  return axios.get(url, withVersionHeaders('2')).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getHasJapaneseListings() {
  return getListings({
    limit: 1,
    marketplace: 'AppExchange_Japanese'
  }).then(response => response.totalResults > 0);
}